import { createFileRoute } from "@tanstack/react-router";
import { WorkspacesList, type WorkspacesSearch } from "../../features/workspaces/workspaces-list";

const TABS = ["all", "running", "stopped", "starting", "failed"] as const;

export const Route = createFileRoute("/_authed/$org/$project/instances/")({
  validateSearch: (s: Record<string, unknown>): WorkspacesSearch => ({
    ...(TABS.includes(s.tab as never) ? { tab: s.tab as WorkspacesSearch["tab"] } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
  }),
  component: WorkspacesPage,
});

function WorkspacesPage() {
  const { org, project } = Route.useParams();
  return <WorkspacesList mode="instance" scope={{ org, project }} search={Route.useSearch()} />;
}
